import { useState } from 'react';
import { Stack, Checkbox, Box } from '@mui/material';
import { field, formThemes } from '../types';

type props = {
	valid: boolean;
	cField: field;
	initialValidation: any;
	handleChange: any;
	formTheme?: formThemes;
	suffix?: string;
};

export default function CheckBox(props: props) {
	const { cField, handleChange } = props;
	const { value, label, helperText, disabled } = cField.props;
	const [isChecked, setIsChecked] = useState(value === 'true');

	const handleCheckedChange = (event: any) => {
		event.target.value = event.target.checked ? 'true' : 'false';
		setIsChecked(event.target.checked);
		handleChange(event);
	};

	return (
		<Stack direction="row" alignItems="center">
			<Checkbox onChange={handleCheckedChange} checked={isChecked} disabled={disabled} />
			<Stack direction="column" fontWeight={700} /* paddingTop={helperText ? '16px' : '0px'}*/>
				{label}
				{helperText && (
					<Box fontWeight={400} sx={{ opacity: '0.47' }}>
						{helperText}
					</Box>
				)}
			</Stack>
		</Stack>
	);
}
